import {
  getListServiceApi,
  deleteServiceApi,
  createServiceApi,
  updateServiceApi,
} from '../../services/listService';
import { setIsLoading, setListService } from '../actions/listService';
import { message } from 'antd';
import i18n from '../../i18n';

export const loadListService = () => async (dispatch) => {
  try {
    dispatch(setIsLoading(true));
    const response = await getListServiceApi();
    const result = response.data;
    dispatch(setListService(result));
  } catch (error) {
    message.error(i18n.t('error.loadingData'));
  } finally {
    dispatch(setIsLoading(false));
  }
};

const DUPLICATE_ERROR_MESSAGE_KEY = {
  'M.ERROR.02': 'error.duplicateServiceCode',
  'M.ERROR.03': 'error.duplicateServiceName',
};

const showServiceError = (error, fallbackKey) => {
  const code = error && error.data && error.data.code;
  message.error(i18n.t(DUPLICATE_ERROR_MESSAGE_KEY[code] || fallbackKey));
};

export const createService = (data) => async (dispatch) => {
  try {
    await createServiceApi(data);
    dispatch(loadListService());
  } catch (error) {
    showServiceError(error, 'error.createService');
    throw error;
  }
};

export const updateService = (data) => async (dispatch) => {
  try {
    await updateServiceApi(data);
    dispatch(loadListService());
  } catch (error) {
    showServiceError(error, 'error.updateService');
    throw error;
  }
};

export const removeServiceById = (id) => async (dispatch) => {
  try {
    await deleteServiceApi(id);
    dispatch(loadListService());
  } catch (error) {
    message.error(i18n.t('error.deleteService'));
  }
};
